// extracted by mini-css-extract-plugin
export default {"click":"Refetch_click__LIyX7","reload":"Refetch_reload__DFULk","button":"Refetch_button__e2K0n"};